import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'

import type {
    FeaturePopupsOpenPopupOptions,
    ClusterFeatureEntity,
    UseFeaturePopupsOptions
} from '@/modules/DispatcherWorkplaceModule/types'

import { reactive } from 'vue'

// opt: UseFeaturePopupsOptions
export default function() {
    const state = reactive({
        is_change_date: false,
        is_add_to_wait_list: false,
        is_assign: false,
        is_self_delivery: false,
        feature: null as ClusterFeature<ClusterFeatureEntity> | null,
    })

    const openPopup = (options: FeaturePopupsOpenPopupOptions) => {
        state.is_change_date = options.is_change_date
        state.is_add_to_wait_list = options.is_add_to_wait_list
        state.is_assign = options.is_assign
        state.is_self_delivery = options.is_self_delivery
        state.feature = options.feature
        
        // opt.onOpenCallback()
    }

    const closePopup = () => {
        state.is_change_date = false
        state.is_add_to_wait_list = false
        state.is_assign = false
        state.is_self_delivery = false
        state.feature = null

        // opt.onCloseCallback()
    }

    return {
        state,
        openPopup,
        closePopup
    }
}